import { observable } from "mobx";
import { AppConstants, Types } from "../../../common/APIConstants";
import { NGLSpotPriceConst } from '../../../constants/nglSpotPrice'
import { NGLTowerTargetsConst, Units } from '../../../constants/nglTowerTargets'
import moment from "moment";
import _ from "lodash";
import ReferenceDataService from '../../referencedata/services/reference-data-service';
class NGLSpotPriceAndTowerTargetsDataStore {
  @observable rowData = [];
  @observable productData = [];
  @observable screenColumnDefinitions = {
    NGLSpotPrice: [],
  };
  @observable hasScreenData = false;
  @observable selectedData = [];
  @observable dataSaved = true;
  @observable SpotPriceReadOnly = false;
  @observable TowerTargetsReadOnly = false;
  @observable isEditable = false;

  getProductsData = async (currentScreen) => {
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screenFilters = [{ name: 'IsActive', value: true },];
      if (currentScreen.screen.name == NGLSpotPriceConst.NGLSpotPrice) {
        shallow.screen.tableName = NGLSpotPriceConst.NGLTeamsSpotPriceProduct;
        shallow.screenColumns = [{ name: "Id" }, { name: "ProductName" }, { name: 'IsActive' }];
        shallow.orderByQuery = { OrderByQuery: "PRODUCTNAME ASC" };
      }
      if (currentScreen.screen.name == NGLTowerTargetsConst.NGLTowerTargets) {
        shallow.screen.tableName = NGLTowerTargetsConst.NGLTeamsTowerTargetParam;
        shallow.screenColumns = [{ name: "Id" }, { name: "Parameter" }, { name: 'IsActive' }];
        shallow.orderByQuery = { OrderByQuery: "PARAMETER ASC" };
      }

      const { data } = await ReferenceDataService.getGridData(shallow);
      this.productData = [];
      this.productData = data;
    } catch (error) {
      if (error.response && error.response.data.includes("Products are not available")) {
        window.toastr.error(error.response.data);
      }

    }
  }

  getScreenData = async (currentScreen, CommonStore, isReadOnly) => {
    CommonStore.toggleLoader();
    this.getProductsData(currentScreen)
    this.hasScreenData = false;
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screenFilters = []
      if (currentScreen.screen.name === NGLSpotPriceConst.NGLSpotPrice) {
        this.SpotPriceReadOnly = isReadOnly;
        shallow.orderByQuery = { orderByQuery: "ProductId ASC, Effective_Start ASC" };
      }

      if (currentScreen.screen.name === NGLTowerTargetsConst.NGLTowerTargets) {
        this.TowerTargetsReadOnly = isReadOnly;
        shallow.orderByQuery = { orderByQuery: "ParameterId ASC, TargetEffectiveFrom ASC" };
      }

      const { data } = await ReferenceDataService.getGridData(shallow);
      const { screen, screenColumns: columns } = currentScreen;
      this.columnDefinitions = [];
      this.rowData = [];
      this.selectedData = [];
      this.columnDefinitions = this.getAllColumnDefinitions(screen, columns);
      this.rowDataFetched = true;
      if (currentScreen.screen.name == NGLSpotPriceConst.NGLSpotPrice) {
        const spotPriceData = data?.map((item) => ({
          ...item,
          ProductId: this.productData?.find(p => p.Id === item.ProductId).ProductName,
          IsActive: item.IsActive ? "Active" : "Inactive",
          Effective_Start: moment(item.Effective_Start).format("MM/DD/YYYY"),
          Effective_End: item.Effective_End !== null && item.Effective_End !== '' ? moment(item.Effective_End).format("MM/DD/YYYY") : item.Effective_End,
          Created_On: moment(item.Created_On).format("MM/DD/YYYY"),
          Updated_On: item.Updated_On !== null && item.Updated_On !== '' ? moment(item.Updated_On).format("MM/DD/YYYY") : item.Updated_On,
        }));
        this.rowData = spotPriceData;
      }

      if (currentScreen.screen.name === NGLTowerTargetsConst.NGLTowerTargets) {
        const towertargetsData = data?.map((item) => ({
          ...item,
          ParameterId: this.productData?.find(p => p.Id === item.ParameterId).Parameter,
          TargetEffectiveFrom: moment(item.TargetEffectiveFrom).format("MM/DD/YYYY"),
          TargetEffectiveUntil: item.TargetEffectiveUntil !== null && item.TargetEffectiveUntil !== '' ? moment(item.TargetEffectiveUntil).format("MM/DD/YYYY") : item.TargetEffectiveUntil,
          Created_On: moment(item.Created_On).format("MM/DD/YYYY"),
          Updated_On: item.Updated_On !== null && item.Updated_On !== '' ? moment(item.Updated_On).format("MM/DD/YYYY") : item.Updated_On,
        }));
        this.rowData = towertargetsData;
      }
      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
    }
  };

  setColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;

        this.screenColumnDefinitions[child.screen.name] = [];
        this.screenColumnDefinitions[child.screen.name] =
          this.getAllColumnDefinitions(screen, columns);
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Data not available for selected date")
      ) {
        window.toastr.error(error.response.data);
      }
    }
  };

  getAllColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push(
        {
          field: column.name,
          headerName: column.title,
          type: "text",
          hide: column.hidden,
          isEditableCol: column.readOnly,
          width: column.width ? column.width : 200,
          required: column.required,

          keyCreator: (params) => {
            return this.getValueFomatter(params, column, screen)
              ? this.getValueFomatter(params, column, screen)
              : params.value;
          },
          editable: (params) => {
            if (screen.name === NGLSpotPriceConst.NGLSpotPrice && this.SpotPriceReadOnly)
              return false;

            if (screen.name === NGLTowerTargetsConst.NGLTowerTargets && this.TowerTargetsReadOnly)
              return false;

            if (params.node.data.isNewRow
              && !NGLSpotPriceConst.ReadOnlyColumns.includes(column.name))
              return true;

            if ((!this.isEditable && params.node.data.ID !== null) &&
              (column.name !== "ProductId" && params.node.data.ProductId !== null)
              && (column.name !== "Effective_Start" && params.node.data.Effective_Start !== null)
              && !NGLSpotPriceConst.ReadOnlyColumns.includes(column.name))

              if ((!this.isEditable && params.node.data.ID !== null)
                && (column.name !== "ParameterId" && params.node.data.ParameterId !== null)
                && (column.name !== "TargetEffectiveFrom" && params.node.data.TargetEffectiveFrom !== null) &&
                !NGLSpotPriceConst.ReadOnlyColumns.includes(column.name))

                return true;

            return screen.canEditRow && !column.readOnly
          },

          cellClassRules: {
            "highlight-cell": (params) => {
              return this.getIsEditable(params, column, screen);
            },
            "grid-cell-custom": (params) => {
              return params.data ? true : false;
            },
          },
          cellRenderer: this.getCellRenderer(column),
          cellRendererParams: (params) =>
            this.getCellRendererParams(column, params),
          cellEditor: this.getCellEditor(column),
          cellEditorParams: (params) => this.getCellEditorParams(column, params),
          valueFormatter: (params) => {
            return this.getValueFomatter(params, column, screen);
          },

          //for cell colors
          cellStyle: (params) => {
            if (column.readOnly && !params.node.data.isNewRow) {
              return { backgroundColor: "LightGray" };
            }
            if (column.required && params.node.data.isNewRow) {
              return { border: "1px solid red" };
            }
          },
        }
      );
    });
    return gridColumns;
  };

  getIsEditable(params, column) {
    if (params.data.productTxt !== "") {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      if (moment(params.data["DateTxt"]) < moment(date)) {
        return false;
      }
    }
    if (this.getIsDataReadOnly() || !params.data) return false;
    else {
      return !column.readOnly;
    }
  }

  getIsDataReadOnly() {
    return false;
  }
  getCellRenderer(column) {
    switch (column.type) {
      case Types.DECIMAL:
        if ([NGLSpotPriceConst.SpotPrice_USD, NGLSpotPriceConst.Conversion_Factor].includes(column.name)) {
          return "decimalFormatter4DigitsWithoutSymbol";
        }
        else if ([NGLTowerTargetsConst.Target_Value, NGLTowerTargetsConst.Min_Value, NGLTowerTargetsConst.Max_Value].includes(column.name)) {
          return "decimalFormatter2Digits";
        }
        else return "decimalFormatter";
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return "SmartSelectClearable";
      case Types.Date:
        return "dateFormatter";
    }
  }
  getCellEditorParams = (column, params) => {
    switch (column.type) {
      case Types.DROPDOWN:
        if (column.name === "IsActive")
          return {
            values: [
              { label: "Active", value: "Active" },
              { label: "Inactive", value: "Inactive" },
            ],
          };
        if (column.name === "Units") {
          return {
            values: Units?.map((item) => {
              return { label: item, value: item };
            }),
          };
        }
        else if (column.name === "ProductId") {
          return {
            values: this.productData?.map((item) => {
              return { label: item.ProductName, value: item.ProductName };
            }),
          };
        }
        else if (column.name === "ParameterId") {
          return {
            values: this.productData?.map((item) => {
              return { label: item.Parameter, value: item.Parameter };
            }),
          };
        }
        else
          return {
            values: column.refLookupData?.lookupValues.values,
            isPopup: true,
          };
    }
  };

  getCellRendererParams(column, params) {
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(
          column.refLookupData.lookupValues,
          params.value
        );
      }
    }
  }

  lookupValue(mappings, key) {
    if (
      !mappings ||
      mappings === "undefined" ||
      !mappings.values.find((item) => item.value == key)
    )
      return null;
    else {
      let label = mappings.values.find((item) => item.value == key).label;
      return label;
    }
  }

  validateEffectiveDate(currentScreen, effectiveDate) {
    const startDate = currentScreen === NGLTowerTargetsConst.NGLTowerTargets ? "Target Effective From" : "Effective Start"
    let isValidate = true;
    if (!moment(effectiveDate, 'MM/DD/YYYY', true).isValid()) {
      isValidate = false;
      window.toastr.error(`${startDate} Date should be in correct format MM/DD/YYYY`);
    }

    if (new Date(effectiveDate).getDate() !== 1) {
      window.toastr.error(`${startDate} Date can only be the first day of the month.`);
      isValidate = false;
    }

    return isValidate;
  }

  getCurrentScreenName = (currentScreen) => {
    return currentScreen.screen.name === NGLSpotPriceConst.NGLSpotPrice ? NGLSpotPriceConst.NGLSpotPrice : NGLTowerTargetsConst.NGLTowerTargets;
  };

  saveData = async (currentScreen, CommonStore) => {
    this.dataSaved = false;
    CommonStore.toggleLoader();
    const toAddUpdate = this.selectedData;
    const screenCols = this.screenColumnDefinitions[this.getCurrentScreenName(currentScreen)];
    const requiredColumns = screenCols.filter((x) => x.required);
    let requiredValidated = true;

    for (let col of requiredColumns) {
      if (toAddUpdate.length > 0) {
        if (
          toAddUpdate[0][col?.field] === null ||
          toAddUpdate[0][col?.field] === ""
        ) {
          requiredValidated = false;
          break;
        }
      }
    }
    if (toAddUpdate.length === 0) {
      window.toastr.error(AppConstants.TOASTER_ERROR_DUPLICATE_TEXT);
      CommonStore.toggleLoader();
    } else if (!requiredValidated || toAddUpdate.length === 0) {
      window.toastr.error(AppConstants.TOASTER_ERROR_REQUIRED_TEXT);
      CommonStore.toggleLoader();
    }
    else if (currentScreen.screen.name === NGLSpotPriceConst.NGLSpotPrice
      && !this.validateEffectiveDate(currentScreen.screen.name, toAddUpdate[0]['Effective_Start']))
      CommonStore.toggleLoader();

    else if (currentScreen.screen.name === NGLTowerTargetsConst.NGLTowerTargets
      && !this.validateEffectiveDate(currentScreen.screen.name, toAddUpdate[0]['TargetEffectiveFrom']))
      CommonStore.toggleLoader();
    else {

      let shallow = Object.assign({}, _.cloneDeep(currentScreen));
      try {
        const addUpdateData = toAddUpdate.map((item) => {
          delete item.isNewRow;
          if (currentScreen.screen.name == NGLSpotPriceConst.NGLSpotPrice)
            item.IsActive =
              item?.IsActive === "Active" || item?.IsActive === true; //this is to set IsActive col value to true for Active and false for in   

          if (currentScreen.screen.name === NGLSpotPriceConst.NGLSpotPrice && isNaN(item.ProductId))
            item.ProductId = this.productData?.find(p => p.ProductName === item.ProductId).Id;

          if (currentScreen.screen.name === NGLTowerTargetsConst.NGLTowerTargets && isNaN(item.ParameterId))
            item.ParameterId = this.productData?.find(p => p.Parameter === item.ParameterId).Id;
          return item;
        });

        shallow.screen.tableName = currentScreen.screen.name == NGLSpotPriceConst.NGLSpotPrice ? NGLSpotPriceConst.NGLTeamsSpotPrice : NGLTowerTargetsConst.NGLTeamsTowerTargets;
        shallow.screenFilters = [];
        shallow.orderByQuery = null;
        shallow.data = addUpdateData;
        const newRowData = shallow.data.filter(p => p.ID === 0);
        if (newRowData.length > 0) {
          shallow.data = newRowData[0];
          await ReferenceDataService.saveData(shallow).then(function () { window.toastr.success(AppConstants.TOASTER_SUCCESS); });
        }
        else {
          await ReferenceDataService.updateData(shallow).then(function () { window.toastr.success(AppConstants.TOASTER_UPDATE); });

        }

        CommonStore.toggleLoader();

        this.selectedData = [];

        this.dataSaved = true;
      } catch (error) {
        window.toastr.error(error?.response?.data || "Something went wrong");
        CommonStore.toggleLoader();
      }
    }
  };


}
export default new NGLSpotPriceAndTowerTargetsDataStore();
